var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Visa",
    transform: "translate(-277 -735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5220",
    "data-name": "Rectangle 5220",
    width: 112,
    height: 56,
    transform: "translate(277 735)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3789",
    d: "M50.122.5C44.713.5,39.879,3.3,39.879,8.484c0,5.941,8.573,6.351,8.573,9.336,0,1.257-1.44,2.382-3.9,2.382a12.949,12.949,0,0,1-6.1-1.572l-1.116,5.227a19.039,19.039,0,0,0,7,1.328c5.914,0,10.568-2.941,10.568-8.21,0-6.278-8.609-6.676-8.609-9.446,0-.984,1.182-2.063,3.635-2.063a12.354,12.354,0,0,1,5.025,1.143L56.043,1.56A16.351,16.351,0,0,0,50.122.5ZM.631.881.5,1.643A25.441,25.441,0,0,1,4.825,2.89C7.465,3.843,7.653,4.4,8.1,6.12L12.94,24.792h6.493l10-23.911H22.958L16.531,17.138,13.908,3.358A2.835,2.835,0,0,0,10.958.881H.631Zm31.409,0L26.959,24.792h6.177L38.2.881H32.04Zm34.452,0c-1.49,0-2.279.8-2.858,2.191l-9.05,21.72h6.478l1.253-3.62h7.892l.762,3.62h5.716L71.7.881H66.492Zm.842,6.46,1.92,8.972H64.111Z",
    transform: "translate(293.5 750.5)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVisa);
export default __webpack_public_path__ + "static/media/Logo_Visa.104983f5f3b85f3cb7d20169a14e52c9.svg";
export { ForwardRef as ReactComponent };